var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25605 0.410551L6.25604 0.41056L6.25366 0.409404C6.03015 0.301125 5.76583 0.341511 5.57479 0.526594L5.57419 0.527167L0.574192 5.34838L0.57378 5.34877C0.433339 5.48375 0.35 5.67901 0.35 5.89327C0.35 6.10494 0.434719 6.30177 0.575036 6.43897C0.575238 6.43917 0.575439 6.43936 0.575642 6.43956L5.57329 11.2585C5.57343 11.2586 5.57357 11.2588 5.57371 11.2589C5.76478 11.4415 6.02828 11.4833 6.2571 11.3755C6.48672 11.2673 6.65 11.0125 6.65 10.7145V8.57172V8.22172H7H10C11.8719 8.22172 13.35 9.84121 13.35 11.7859C13.35 12.9079 12.9046 13.5791 12.5555 13.9333L12.5529 13.9359C12.4208 14.0671 12.35 14.2141 12.35 14.3404C12.35 14.533 12.4917 14.65 12.6156 14.65C12.6596 14.65 12.6798 14.6416 12.6887 14.6363L12.6887 14.6362L12.6922 14.6342C13.2337 14.3177 15.65 12.7164 15.65 9.10741C15.65 6.02327 13.3219 3.56482 10.5 3.56482H7H6.65V3.21482V1.07205C6.65 0.77549 6.48476 0.519223 6.25605 0.410551Z",
    fill: "#373939",
    stroke: "white",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.79443c3fa17d0ac07882aee65527eabc.svg";
export { ForwardRef as ReactComponent };